module.exports = {
  props: {
    styles: {
      required: false,
      type: Array | String,
      default: () => []
    }
  }
}
